<template>
    <div>
        <div style="padding: 0 20px">
            <div class="top">
                <div>
                    <el-button type="primary" @click="addDiagnose" style="width: 110px">新增供应商</el-button>
                </div>
            </div>
            <div>
                <el-table :data="tableData"
                          :header-cell-style="{'padding-left': '2%'}"
                          :cell-style="{'padding-left': '2%'}">
                    <el-table-column prop="supplierName" label="药房名称"></el-table-column>
                    <el-table-column prop="simpleName" label="简称"></el-table-column>
                    <el-table-column prop="linkMan" label="联系人"></el-table-column>
                    <el-table-column prop="linkMobile" label="联系电话"></el-table-column>
                    <el-table-column label="操作">
                        <template slot-scope="scope">
                            <el-button type="text" @click="editDiagnose(scope.row)">查看编辑</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div class="pagination">
                <el-pagination
                        background
                        layout="total, prev, pager, next"
                        :current-page="pageNum"
                        :page-size="pageSize"
                        :total="total"
                        @current-change="handlePageChange"
                ></el-pagination>
            </div>
        </div>
        <el-dialog title="新增医院/诊所" :visible.sync="dialogAddVisible" width="560px">
            <el-form  ref="addHospital" size="small" label-width="90px">
                <el-form-item label="名称:" prop="hospitalName">
                    <el-input style="width: 282px"></el-input>
                </el-form-item>
                <el-form-item label="简介:" prop="hospitalName">
                    <el-input type="textarea" style="width: 282px"></el-input>
                </el-form-item>
                <el-form-item label="负责人:" prop="chargePerson">
                    <el-input  style="width: 282px"></el-input>
                </el-form-item>
                <el-form-item label="手机号:" prop="account">
                    <el-input  style="width: 282px"></el-input>
                </el-form-item>
                <div class="dialog-set">
                    <el-form-item label="省市区" prop="province">
                        <el-select placeholder="选择省"
                                    style="width: 140px;">
                            <el-option v-for="item in province" :key="item.provinceId"
                                       :label="item.province" :value="item.provinceId"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item prop="city" label-width="0">
                        <el-select  placeholder="选择市"
                                    style="width: 135px">
                            <el-option v-for="item in city" :key="item.cityId"
                                       :label="item.city" :value="item.cityId"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item prop="district" label-width="0">
                        <el-select  placeholder="选择区/县"
                                   style="width: 135px;">
                            <el-option v-for="item in area" :key="item.areaId"
                                       :label="item.area" :value="item.areaId"></el-option>
                        </el-select>
                    </el-form-item>
                </div>


<!--                <el-form-item label="处方剂型:" prop="medicinesDosage">-->
<!--                    <el-checkbox-group >-->
<!--                        <el-checkbox v-for="(item,index) in medicinesDosage" :key="index" :label="item"></el-checkbox>-->
<!--                    </el-checkbox-group>-->
<!--                </el-form-item>-->
<!--                <el-form-item label="代煎服务:" prop="decoction">-->
<!--                    <el-radio-group v-model="hospitalAdd.decoction">-->
<!--                        <el-radio v-for="(item,index) in isDecocting" :key="index" :label="item">{{ item }}</el-radio>-->
<!--                    </el-radio-group>-->
<!--                </el-form-item>-->
<!--                <el-form-item label="处方大全:" prop="prescribe">-->
<!--                    <el-radio-group v-model="hospitalAdd.prescribe">-->
<!--                        <el-radio v-for="(item,index) in prescribeType" :key="index" :label="item">{{ item }}</el-radio>-->
<!--                    </el-radio-group>-->
<!--                </el-form-item>-->
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogAddVisible = false" style="width: 76px">取 消</el-button>
                <el-button type="primary" @click="confirmAdd" style="width: 76px;">确 定</el-button>
            </div>
        </el-dialog>
        <el-dialog title="编辑" :visible.sync="dialogEditVisible" width="520px">

            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogEditVisible = false" style="width: 76px;">取 消</el-button>
                <el-button type="primary" @click="confirmEdit" style="width: 76px;">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                // 表格信息
                tableData: [
                    {
                        diagnoseId: '1',
                        supplierName: '第三个',
                        simpleName: '通过后',
                        linkMan: '发生过',
                        linkMobile: '12345678912',
                    }
                ],
                // 分页信息
                pageNum: 1,
                pageSize: 10,
                total: 1,
                pages: 1,
                province: [],
                city: [],
                area: [],
                // 弹窗开关
                dialogAddVisible: false,
                dialogEditVisible: false,
                // 新增诊断弹窗数据
                diagnoseAdd:{
                },
                // 编辑诊断弹窗数据
                diagnoseEdit:{
                },
            }
        },
        methods: {
            // 获取列表
            queryDiagnose() {
                console.log("aaa")
            },
            // 表格换页
            handlePageChange(val) {
                this.pageNum = val;
                this.queryDiagnose();
            },
            getProvince() {
                this.axios.get('/api-b/10028/100071',{
                    headers:{
                        Authorization: this.authorization
                    }
                }).then(res => {
                    if (res.data.code === 10000) {
                        this.province = res.data.data
                    } else {
                        this.$message.error(res.data.message)
                    }
                })
            },
            // 打开新增弹窗
            addDiagnose() {
                this.dialogAddVisible =true
            },
            // 确定添加
            confirmAdd() {
                console.log(this.diagnoseAdd.diagnoseName)
            },
            // 打开编辑弹窗
            editDiagnose(data) {
                this.dialogEditVisible = true
                console.log(data)
                this.diagnoseEdit.diagnoseName = data.diagnoseName
            },
            // 确认编辑
            confirmEdit() {
                console.log(this.diagnoseEdit.diagnoseName)
            },
        },
        created() {
            this.queryDiagnose()
        }
    }

</script>
<style>

</style>
<style scoped>
    .top {
        display: flex;
        flex-direction: row;
        justify-content: flex-end;
        margin-top: 12px;
        height: 52px;
    }
</style>